import { useLocalizedStringFormatter } from "react-aria";
import locales from "./locales.ts";

export default function useI18n() {
  return useLocalizedStringFormatter(locales, "@cvpartner/design-system");
}
